import { createContext } from 'react';
import { reactFlowInstanceStore } from '@src/atoms';

export const ReactflowInstanceContext = createContext<typeof reactFlowInstanceStore>(reactFlowInstanceStore);

interface ReactflowInstanceProviderProps {
  children: React.ReactNode;
}
export const ReactflowInstanceProvider: React.FC<ReactflowInstanceProviderProps> = ({ children }) => (
  <ReactflowInstanceContext.Provider value={reactFlowInstanceStore}>
    {children}
  </ReactflowInstanceContext.Provider>
);
